export default "__VITE_ASSET__BdHYrN5s__"